import React, { PropsWithChildren, ReactElement } from 'react';
import classnames from 'classnames';
import './index.css';

type CardBorderTypes =
  | 'none'
  | 'bordered'
  | 'bordered-top'
  | 'bordered-right'
  | 'bordered-bottom'
  | 'bordered-left';

export type CardProps = PropsWithChildren<{
  borderType?: CardBorderTypes;
  className?: string;
  loose?: boolean;
  raised?: boolean;
  testId?: string;
  well?: boolean;
}>;

export function Card({
  borderType = 'none',
  children,
  className,
  loose = true,
  raised = true,
  testId,
  well = false,
}: CardProps): ReactElement {
  const classes = classnames('panel', 'clearfix', className, {
    [`panel--${borderType}`]: !!borderType,
    'panel--loose': loose,
    'panel--raised': raised,
    'panel--well': well,
  });

  return (
    <div className={classes} aria-label="Card" data-testid={testId}>
      {children}
    </div>
  );
}
